import React from 'react'
import { ResponsiveTableRow, Row, useContainerWidth } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { formatDate, niceBytes, treeStatusKeyMap } from '../../../helpers'
import GenealogyActions from './GenealogyActions'
import TreeNameOrFileTitle from '../../upload-page/upload-row/TreeNameOrFileTitle'
import GenealogyTreeMenuAction from './GenealogyTreeMenuAction'
import useGenealogyTreeMenu from './useGenealogyTreeMenu'

const GenealogyRow = ({ tree }) => {
  const [t] = useTranslation()
  const { name, createDate, fileSize, treeStatus, personCount } = tree
  const atWidth = useContainerWidth()
  // On medium screens, use the icon-button menu to avoid squishing the action buttons
  const isMediumView = atWidth({ default: false, md: true, xl: false })
  const { menuButtonProps, genealogyActionsOverlay, onMenuClick } = useGenealogyTreeMenu()

  return (
    <>
      <ResponsiveTableRow
        data-testid={`row_${name}`}
        column1={<TreeNameOrFileTitle name={name} />}
        column2={formatDate(createDate)}
        column3={<div data-testid="personCount">{personCount}</div>}
        column4={<div data-testid="fileSize">{niceBytes(fileSize)}</div>}
        column5={t(treeStatusKeyMap[treeStatus])}
        column6={
          isMediumView ? (
            <Row alignX="end">
              <GenealogyTreeMenuAction menuButtonProps={menuButtonProps} onMenuClick={onMenuClick} tree={tree} />
            </Row>
          ) : (
            <GenealogyActions tree={tree} />
          )
        }
      />
      {genealogyActionsOverlay}
    </>
  )
}

export default GenealogyRow
